import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { NavigationService } from './services/navigation.service';

export function provideNavigation(): EnvironmentProviders {
  return makeEnvironmentProviders([NavigationService]);
}
